// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2Hfvj","search":"Settings_search__38q7S","filter":"Settings_filter__1A_XS"};